import { useTranslation } from 'react-i18next';
import { AssetDetailsLinkList } from 'src/components/assets/AssetDetailsLinkList';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { TAssetStage, TSecurityType } from '@brickwise/asset-validation/dist/schema/enums';
import { Routes } from 'src/router/Routes';
import { isNullUndefinedOrEmpty } from 'src/util/utils';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { useAsset } from '../../context-providers/AssetContext';
import { useState } from 'react';
import { Alert, Button, Snackbar, TableCell, TableRow, Typography } from '@mui/material';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { SerialNumberploadDialog } from 'src/components/assets/asset-notary/SerialNumberUploadDialog';
import { Add, Download } from '@mui/icons-material';
import { AutogenerateDialog } from 'src/components/assets/dialogs/autogenerateDialog';
import { useAllSerialNumbers } from 'src/hooks/useAllSerialNumbers';
import { LaunchpadTable } from 'src/components/mui-overrides/LaunchpadTable';
import { getAllSerialNumbersCSV } from 'src/api/stoApi';
import { LoadingButton } from '@mui/lab';
// import { useNavigate } from 'react-router-dom';

export const AssetSerialNumber = () => {
  const { t } = useTranslation();
  const { asset } = useAsset();
  const [reload, setReload] = useState<boolean>(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  // const navigate = useNavigate();

  // useEffect(() => {}, [asset]);

  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ASSETS.ROOT,
            label: t('dashboard.breadcrumbs.assets'),
            icon: <ApartmentOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
          {
            link: Routes.ASSETS.EDIT.replace(':assetId', asset?.id ?? ''),
            label: (isNullUndefinedOrEmpty(asset?.descriptions?.title) ? asset?.id : asset?.descriptions?.title) ?? '',
          },
          {
            link: Routes.ASSETS.RECORDS.replace(':assetId', asset?.id ?? ''),
            label: t('dashboard.breadcrumbs.records'),
          },
        ]}
        headline={asset ? (isNullUndefinedOrEmpty(asset.descriptions?.title) ? asset.id : (asset.descriptions.title as string)) : ''}
      >
        {asset && (
          <AssetDetailsLinkList
            assetId={asset.id}
            useSerialNumber={asset.useSerialNumber}
            active={'serial-number'}
            isPrimary={asset?.investmentDetails.stage === TAssetStage.primary}
            isSecondary={asset?.investmentDetails.stage === TAssetStage.secondary}
            isPreorder={asset?.investmentDetails.stage === TAssetStage.preorder}
            isKESt={
              asset?.investmentDetails?.securityType === TSecurityType.participationRightDebtCapital ||
              asset?.investmentDetails?.securityType === TSecurityType.participationRightDebtCapitalPartialSale
            }
            securityType={asset?.investmentDetails?.securityType}
          />
        )}
      </SiteHeader>
      {
        <>
          <SerialNumber
            assetId={asset.id}
            openSuccessAlert={() => {
              setReload(!reload);
              setOpenSuccessAlert(true);
            }}
          />
        </>
      }
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={openSuccessAlert}
        autoHideDuration={6000}
        onClose={() => setOpenSuccessAlert(false)}
      >
        <Alert onClose={() => setOpenSuccessAlert(false)} severity="success" sx={{ width: '100%' }}>
          {t('dashboard.assets.addedit.successalert')}
        </Alert>
      </Snackbar>
    </>
  );
};

interface Props {
  assetId: string;
  openSuccessAlert: () => void;
}

export const SerialNumber = ({ assetId, openSuccessAlert }: Props) => {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState<boolean>(false);
  const [isAutoGenerateDialogOpen, setIsAutoGenerateDialogOpen] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { loading, serialNumbers } = useAllSerialNumbers(assetId, page, pageSize);
  const { t } = useTranslation();

  // const downloadCSV = async () => {
  //   if (!assetId) throw new Error('assetId is not defined');
  //   const result:any = await getAllSerialNumbersCSV(assetId);
  //   const { error, data } = result;
  //   console.log('result', result);
  //   if (error) return;
  //   if (data) {
  //     const url = window.URL.createObjectURL(new Blob([data.data], { type: 'text/csv' }));
  //     const link = document.createElement('a');
  //     const fileName = `serial_numbers_${assetId}.csv`;
  //     link.href = url;
  //     link.setAttribute('download', fileName);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   }
  // };

  // open the url

  return (
    <>
      <LaunchpadCard>
        <SerialNumberploadDialog
          isOpen={isUploadDialogOpen}
          assetId={assetId}
          closeDialog={() => {
            setIsUploadDialogOpen(false);
          }}
          openSuccessAlert={openSuccessAlert}
        />
        <AutogenerateDialog
          open={isAutoGenerateDialogOpen}
          assetId={assetId}
          handleClose={() => {
            setIsAutoGenerateDialogOpen(false);
          }}
          triggerRefresh={() => {
            console.log('referesh');
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', paddingBottom: '24px' }}>
          <Typography gutterBottom variant="h6">
            {t('dashboard.assets.serialNumber.title')}
          </Typography>

          <Typography gutterBottom variant="h6">
            {t('dashboard.assets.serialNumber.title')}
          </Typography>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', paddingBottom: '24px' }}>
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => setIsUploadDialogOpen(true)}>
            {t('dashboard.assets.serialNumbers.uploadBtnLabel')}
          </Button>

          <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => setIsAutoGenerateDialogOpen(true)}>
            {t('dashboard.assets.serialNumbers.autogenerate')}
          </Button>
        </div>
      </LaunchpadCard>
      <div style={{ marginTop: '20px' }}>
        {loading ? (
          <Typography variant="body1">Loading...</Typography>
        ) : (
          <>
            <CSVButton assetId={assetId} />
            <LaunchpadTable
              page={page}
              length={10000}
              hidePagination={false}
              rowsPerPage={pageSize}
              setRowsPerPage={(rowsPerPage) => {
                console.log('rowsPerPage', rowsPerPage);
                setPage(1);
                setPageSize(rowsPerPage);
              }}
              setPage={setPage}
              renderHeader={() => (
                <TableRow>
                  <TableCell>Serial</TableCell>
                  <TableCell>userId</TableCell>
                  <TableCell>name</TableCell>
                  <TableCell>email</TableCell>
                </TableRow>
              )}
              renderRows={() =>
                serialNumbers.map((row: any, index: number) => (
                  <TableRow key={index.toString()}>
                    <TableCell>{row.serialNumber}</TableCell>
                    <TableCell>{row.userId ? row.userId : 'Not Assigned'}</TableCell>
                    <TableCell>{row.userId ? row.user.firstName + ' ' + row.user.lastName : ''}</TableCell>
                    <TableCell>{row.userId ? row.user.email : ''}</TableCell>
                  </TableRow>
                ))
              }
            />
          </>
        )}
      </div>
    </>
  );
};

const CSVButton = ({ assetId }: { assetId: string }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const downloadCSV = async () => {
    if (!assetId) throw new Error('assetId is not defined');
    setIsLoading(true);
    const result: any = await getAllSerialNumbersCSV(assetId);
    const { error, data } = result;
    console.log('result', result);
    if (error) return;
    if (data) {
      const url = window.URL.createObjectURL(new Blob([data.data], { type: 'text/csv' }));
      const link = document.createElement('a');
      const fileName = `serial_numbers_${assetId}.csv`;
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setIsLoading(false);
  };

  return (
    <LoadingButton
      loading={isLoading}
      style={{ margin: '10px' }}
      variant="contained"
      color="primary"
      startIcon={<Download />}
      onClick={() => downloadCSV()}
    >
      CSV
    </LoadingButton>
  );
};
